import { styled } from 'baseui'

export const ResultsColumn = styled('section', {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
})

export const ResultsTitle = styled('h2', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  fontSize: '1rem',
  fontWeight: 600,
  color: $theme.colors.textPulseStrong,
}))

export const ResultsIntro = styled('p', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  fontSize: '0.8125rem',
  color: $theme.colors.textPulseMuted,
}))

export const ResultsEmpty = styled('p', ({ $theme }) => ({
  marginTop: 0,
  marginBottom: 0,
  fontSize: '0.8125rem',
  fontStyle: 'italic',
  color: $theme.colors.textPulseMuted,
}))
